import { HttpClient, HttpHeaders } from '@angular/common/http';

import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RequestService {
  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  post( path: string, data: any, objHeaders: any = null, otherServer?:string ) : Observable<any> {
    const server = ( otherServer ) ? otherServer : environment.http.server;
    let user = this.getSession();
    let headers
    if( objHeaders ) {
      if( user?.session ) {
        objHeaders["Authorization"] = `Bearer ${user.access_token}`
      }
      headers = new HttpHeaders( objHeaders )
    }else if( user?.session ){
      headers = new HttpHeaders({'Authorization': `Bearer ${user.access_token}`})
    }
    return this.http.post( `${server}${path}`, data, {headers} )
  }

  get( path: string, query: string, objHeaders: any = null, otherServer?:string ) : Observable<any> {
    const server = ( otherServer ) ? otherServer : environment.http.server;
    let user = this.getSession();
    let headers
    if( objHeaders ) {
      if( user?.session ) {
        objHeaders["Authorization"] = `Bearer ${user.access_token}`
      }
      headers = new HttpHeaders( objHeaders )
    }else if( user?.session ){
      headers = new HttpHeaders({'Authorization': `Bearer ${user.access_token}`})
    }
    return this.http.get( `${server}${path}${query}`, {headers} );
  }

  patch( path: string, data: any, objHeaders: any = null, otherServer?:string ) : Observable<any> {
    const server = ( otherServer ) ? otherServer : environment.http.server;
    let user = this.getSession();
    let headers
    if( objHeaders ) {
      if( user?.session ) {
        objHeaders["Authorization"] = `Bearer ${user.access_token}`
      }
      headers = new HttpHeaders( objHeaders )
    }else if( user?.session ){
      headers = new HttpHeaders({'Authorization': `Bearer ${user.access_token}`})
    }
    return this.http.patch( `${server}${path}`, data, {headers} )
  }

  getSession() {
    let data : any
    if (localStorage.getItem(environment.localStorage.user)) {
      data = localStorage.getItem(environment.localStorage.user)
      if ( !environment.regex.base64.test( data ) ) {
        this.authService.cerrarSesion()
      } else {
        return atob( data ) != null ? JSON.parse(atob( data )!) : null;
      }
    }
  }

  /**
   * La función `download` envía una solicitud HTTP GET a un servidor, si existe una sesión activa se agrega
   * el token a los headers automáticamente.
   *
   * @param {string} path - El parámetro path es una cadena que representa el punto final o la ruta del
   * API a la que desea realizar una solicitud GET. Especifica la ubicación del recurso que desea
   * recuperar.
   * @param {any} [_headers=null] - El parámetro `headers` es un objeto opcional que contiene
   * encabezados adicionales que desea incluir en la solicitud HTTP. Estos encabezados se pueden usar para
   * autenticación, autorización o cualquier otro encabezado personalizado requerido por el servidor. Si no hay encabezados
   * se proporcionan, el valor se establece en `null`.
   *
   * @example
   * #Solicitud sin headers
   * service.get( '/path', 'q=alimento&page=1&max=10' )
   * 
   * #Solicitud con headers
   * service.get( '/path', 'q=alimento&page=1&max=10', { client: 'nombre-cliente' } )
   * 
   * @returns Observable - Responde la URL desde la que podrán descargar el archivo.
   */
  download(path: string, _headers: any = null) : Observable<any> {
    return new Observable( observer => {
      const server = environment.http.server;
      let user = this.getSession();
      if( user && user.access_token ) {
        if( _headers ) {
          _headers['Authorization'] = `Bearer ${user.access_token}`;
        }else{
          _headers = {
            'Authorization': `Bearer ${user.access_token}`
          }
        }
      }
      let headers : any
      if( _headers ) {
        headers = new HttpHeaders( _headers )
      }
      
      this.http.get( `${server}${path}`, {headers: headers} )
        .subscribe({
          next: (resp:any) => {
            observer.next( resp )
          },
          error: err => {
            observer.error( err )
          }
        })
    } )
  }
}
